



if ($("#pegelStamm").length > 0) {
    initStationSelect();
}
